import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'

export const enum PageIdWoofzPawNup {
  WELCOME_PAW_NUP = PageId.WELCOME_PAW_NUP,
  HOW_IT_WORKS_PAW_NUP = PageId.HOW_IT_WORKS_PAW_NUP,
  INTRODUCTION_PAW_NUP = PageId.INTRODUCTION_PAW_NUP,
  MORNING_WALK_PAW_NUP = PageId.MORNING_WALK_PAW_NUP,
  EVENING_WALK_PAW_NUP = PageId.EVENING_WALK_PAW_NUP,
  FEEDING_PAW_NUP = PageId.FEEDING_PAW_NUP,
  VET_CARE_PAW_NUP = PageId.VET_CARE_PAW_NUP,
  TRAINING_PAW_NUP = PageId.TRAINING_PAW_NUP,
  DISCIPLINE_PAW_NUP = PageId.DISCIPLINE_PAW_NUP,
  CLEANUP_PAW_NUP = PageId.CLEANUP_PAW_NUP,
  TREATS_PAW_NUP = PageId.TREATS_PAW_NUP,
  KISSES_PAW_NUP = PageId.KISSES_PAW_NUP,
  GROOMING_PAW_NUP = PageId.GROOMING_PAW_NUP,
  NIGHT_DUTY_PAW_NUP = PageId.NIGHT_DUTY_PAW_NUP,
  RULES_PAW_NUP = PageId.RULES_PAW_NUP,
  ALLOWED_ON_BED_PAW_NUP = PageId.ALLOWED_ON_BED_PAW_NUP,
  TABLE_SCRAPS_PAW_NUP = PageId.TABLE_SCRAPS_PAW_NUP,
  WHINES_PAW_NUP = PageId.WHINES_PAW_NUP,
  COMMANDS_PAW_NUP = PageId.COMMANDS_PAW_NUP,
  LISTEN_TO_PAW_NUP = PageId.LISTEN_TO_PAW_NUP,
  CREATING_AGREEMENT_PAW_NUP = PageId.CREATING_AGREEMENT_PAW_NUP,
  CONFLICT_PROOF_PAW_NUP = PageId.CONFLICT_PROOF_PAW_NUP,
  EMAIL_PAW_NUP = PageId.EMAIL_PAW_NUP,
  AGREEMENT_PAW_NUP = PageId.AGREEMENT_PAW_NUP,
  DOWNLOAD_PAW_NUP = PageId.DOWNLOAD_PAW_NUP,
}

type TIdToPageMapWoofzPawNup = Record<PageIdWoofzPawNup, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_PAW_NUP: TIdToPageMapWoofzPawNup = {
  welcome_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/hello/HelloPage').then((m) => ({
        default: m.HelloPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_paw_nup/pages/hello/HelloPage'),
  },
  how_it_works_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/urge/HowItWorks').then((m) => ({
        default: m.HowItWorksPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_paw_nup/pages/urge/HowItWorks'),
  },
  introduction_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/urge/Introduction').then(
        (m) => ({
          default: m.IntroductionPage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/urge/Introduction'),
  },
  morning_walk_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/MorningWalk').then(
        (m) => ({
          default: m.MorningWalks,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/MorningWalk'),
  },
  evening_walk_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/EveningWalk').then(
        (m) => ({
          default: m.EveningWalks,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/EveningWalk'),
  },
  feeding_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/Feeding').then(
        (m) => ({
          default: m.Feeding,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/Feeding'),
  },
  vet_care_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/VetCare').then(
        (m) => ({
          default: m.VetCare,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/VetCare'),
  },
  training_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/Training').then(
        (m) => ({
          default: m.Training,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/Training'),
  },
  discipline_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/Discipline').then(
        (m) => ({
          default: m.Discipline,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/Discipline'),
  },
  cleanup_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/Cleanup').then(
        (m) => ({
          default: m.Cleanup,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/Cleanup'),
  },
  treats_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/Treats').then(
        (m) => ({
          default: m.Treats,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_paw_nup/pages/questions/Treats'),
  },
  kisses_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/Kisses').then(
        (m) => ({
          default: m.Kisses,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_paw_nup/pages/questions/Kisses'),
  },
  grooming_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/Grooming').then(
        (m) => ({
          default: m.Grooming,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/Grooming'),
  },
  night_duty_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/NightDuty').then(
        (m) => ({
          default: m.NightDuty,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/NightDuty'),
  },
  rules_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/urge/RulesPage').then((m) => ({
        default: m.RulesPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_paw_nup/pages/urge/RulesPage'),
  },
  allowed_on_bed_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/AllowOnBed').then(
        (m) => ({
          default: m.AllowOnBed,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/AllowOnBed'),
  },
  table_scraps_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/TableScraps').then(
        (m) => ({
          default: m.TableScraps,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/TableScraps'),
  },
  whines_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/Whines').then(
        (m) => ({
          default: m.Whines,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_paw_nup/pages/questions/Whines'),
  },
  commands_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/Commands').then(
        (m) => ({
          default: m.Commands,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/Commands'),
  },
  listen_to_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/ListenTo').then(
        (m) => ({
          default: m.ListenTo,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/questions/ListenTo'),
  },
  creating_agreement_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/urge/UrgePrepareScreen').then(
        (m) => ({
          default: m.UrgePrepareScreen,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/urge/UrgePrepareScreen'),
  },
  conflict_proof_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/result/ResultPage').then(
        (m) => ({
          default: m.ResultPage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/result/ResultPage'),
  },
  email_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_paw_nup/pages/email/Email'),
  },
  agreement_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/agreement/Agreement').then(
        (m) => ({
          default: m.AgreementPage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/agreement/Agreement'),
  },
  download_paw_nup: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_paw_nup/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_paw_nup/pages/download-app/DownloadApp'),
  },
}
